import script from "./object_dayCollectionCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./object_dayCollectionCourse.vue?vue&type=script&setup=true&lang=js"

import "./object_dayCollectionCourse.vue?vue&type=style&index=0&id=0e68a918&lang=css&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e68a918"]])

export default __exports__